import { Controller } from "@hotwired/stimulus";

// Holds a ui--switch on while any "implying" switch is on, and locks it there. Nexus treats requiring a
// customer's email or phone as requiring a customer, so the page shouldn't offer the combination it ignores.
export default class extends Controller {
  static targets = ["implied", "implying"];

  connect() {
    this.update();
  }

  update() {
    const locked = this.implyingTargets.some(
      (target) => this.switchIn(target).dataset.state === "checked",
    );
    const implied = this.switchIn(this.impliedTarget);
    const button = implied.querySelector("button");

    if (locked && implied.dataset.state !== "checked") {
      button.disabled = false;
      button.click();
    }
    button.disabled = locked;
  }

  switchIn(target) {
    return target.querySelector("[data-controller~='ui--switch']");
  }
}
